export default __webpack_public_path__ + "static/modalSplash-dc10d5233550b952c75919fc3952fe8d.svg";